import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PasswordStorageService} from '../services/password-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AdminTokenInterceptorService implements HttpInterceptor {

  private password: string;

  constructor(private passwordStorageService: PasswordStorageService) {
    this.passwordStorageService.passwordEvent.subscribe(password => {
      this.password = password;
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = req;
    if (this.password) {
      newReq = req.clone({setHeaders: {'Token': this.password}});
    }
    return next.handle(newReq);
  }
}
